import { render, staticRenderFns } from "./pscx.vue?vue&type=template&id=711e96eb&scoped=true&"
import script from "./pscx.vue?vue&type=script&lang=js&"
export * from "./pscx.vue?vue&type=script&lang=js&"
import style0 from "./pscx.vue?vue&type=style&index=0&id=711e96eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711e96eb",
  null
  
)

export default component.exports